// extracted by mini-css-extract-plugin
module.exports = {"presentationItemHolder":"PresentationItem_presentationItemHolder__13rvZ","presentationItemHolderSafari":"PresentationItem_presentationItemHolderSafari__2qlRc"};